<template>
    <v-card class="pa-2" :loading="loading" rounded="xl" color="grey lighten-2">
        <div v-if="!loading" class="pa-2 grey lighten-4" style="height: 250px; overflow: auto; scrollbar-width: none;">
            <v-row dense justify="start" align="center">
                <v-col cols="4" align-self="end" v-for="item in apps" :key="item.id" class="pa-2">
                    <a :href="item.app_url" target="_blank" style="text-decoration: none;">
                        <div class="text-center">
                            <img :src="item.logo" alt="logo" width="40px">
                        </div>
                        <div class="mt-2 font-weight-medium text-center grey--text text--darken-3"><small>{{ item.name_eng }}</small></div>
                    </a>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        apps: [],
        loading: false,
    }),
    methods: {
        getApps() {
            if (!this.User) return

            this.loading = true
            this.$axios.get(`/api/pgo-apps`).then((resp) => {
                this.apps = resp.data
            }).finally(() => this.loading = false)
        }
    },
    mounted() {
        this.getApps()
    }
}
</script>

<style scoped>
</style>